export class EventModes {
  public static readonly None = "none";
  public static readonly Static = "static";
  public static readonly Passive = "passive";
}
